<template>
    <div class="active-selection">
        <div class="active-selection__sequence">
            <transition
                appear
                name="fade-quick"
                mode="out-in">
                <video
                    :key="activeType"
                    muted
                    autoplay
                    playsinline
                    width="640"
                    height="640"
                    @ended="onEnded">
                    <source :src="src" type="video/mp4" @error="onError">
                </video>
            </transition>
            <img
                v-if="useFallback"
                :key="`${activeType}-fallback`"
                :src="fallbackSrc"
                width="1000"
                height="1000"
                class="active-selection__fallback"
                @load="onLoadFallback">
        </div>
        <div class="active-selection__text">
            <!--
            <p>
                En {{ activeType }} koster deg {{ animatedTotal }} i året.
            </p>
            -->
            <p class="secondary">
                Utregnet av Samfunnsøkonomisk Analyse.
                Tall fra Opplysningsrådet for veitrafikken.
            </p>
        </div>
    </div>
</template>

<script>
import { formatNOK } from '@/utils/currency';
export default {
    name: 'ActiveSelection',
    data () {
        return {
            total: 0,
            useFallback: false
        };
    },
    computed: {
        activeSelection () {
            return this.$store.getters.activeSelection;
        },
        activeLabel () {
            return this.activeSelection.label || '';
        },
        activeType () {
            return this.activeSelection.type || '';
        },
        activeTotal () {
            return this.activeSelection.total;
        },
        animatedTotal () {
            return formatNOK(this.total.toFixed(0),' kr');
        },
        src () {
            return (this.activeSelection.video && `${this.activeSelection.video}?r=${(Math.random() * 1000).toFixed()}`) || '';
        },
        fallbackSrc () {
            return this.activeSelection.fallback || '';
        },
        idleTime () {
            return this.activeSelection.idleTime || 3;
        }
    },
    watch: {
        activeTotal (val) {
            this.$anime({
                targets: this,
                total: val,
                duration: 1000,
                easing: 'easeOutSine'
            });
        },
        activeType (val) {
            // Switch video
        }
    },
    mounted () {
        const val = this.activeTotal;
        this.$anime({
            targets: this,
            total: val,
            duration: 1000,
            easing: 'easeOutSine'
        });
    },
    methods: {
        onEnded (e) {
            const video = e.target;
            video.currentTime = this.idleTime;
            video.play();
        },
        onError (e) {
            this.useFallback = true;
        },
        onLoadFallback (e) {
            const image = e.target;
            this.$nextTick(() => {
                image.style.opacity = 1;
            }, 60);
        }
    }
};
</script>

<style lang="scss">
.active-selection{
    $block: &;
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    &__sequence{
        position: absolute;
        top: 0;
        left: 50%;
        width: 420px;
        height: 420px;
        transform: translateX(-50%);
        video{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: color(white);
        }
    }
    &__fallback{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity .5s ease-in-out;
    }
    &__text{
        position: relative;
        z-index: 2;
        padding-top: 360px;
        p{
            margin: 0;
            @include breakpoint(medium down){
                text-align: center;
            }
        }
    }
}
</style>
